export default "__VITE_ASSET__CUQWsqBh__"